<template>
    <div class="index">
        <Header></Header>
        <!-- <div id="nav">
            <div id="UIFrame_989897" style="display: block;">
                <div class="banner_box" id="jsSlide">
                    <div class="swiper-container" id="swiper-container1" style="height:350px;width:100%;">
                        <div class="swiper-wrapper" id="swiperWrapper">
                            <ul class="banner swiper-slide swiper-no-swiping">
                                <li class="jslinkUrl">
                                    <img alt=""
                                        src="/sxportal/images/gysx.jpg" style="height:350px;width:100%">
                                    </li>
                            </ul>
                        </div>
                        <div class="swiper-pagination" id="swiper-pagination1"></div>
                    </div>

                </div>
            </div>
        </div> -->
        <div class="introduce">
            <div class="wrap">
                <!-- <div class="sunshine_nav">
                </div> -->
                <div class="sunshine_content" id="sunshine_content">
                    <div id="UIFrame_202855" style="display: block;">
                        <div class="content_title">
                            <h3>集团概况</h3>
                            <p class="crumbs">
                                当前位置：
                                <router-link :to="{ path: '/' }">
                                    <i class="home"></i>
                                    首页
                                </router-link>
                                &gt;
                                <a href="#">关于景初</a>
                                &gt;
                                <a href="#">集团概况</a>
                            </p>
                        </div>
                        <div id="info_select" style="margin: 0 auto;padding: 0 30px;">
                            <p class="content_write">
                                <h1 style="font-size: 45px;font-weight: normal;color: rgb(41, 142, 227);margin: 30px 0;text-align: center;">
                                    企业介绍
                                </h1>
                                <div style="line-height:40px;padding: 0 100px;margin-bottom:50px;font-size:18px;text-indent:2em"> 
                                    <p style="font-size:18px;text-indent:2em">
                                        湖北景初文化传媒有限公司成立于2021年8月19日，公司位于湖北省、武汉市、东湖新技术开发区光谷大道特1号国际企业中心三期，
                                        公司多年致力于出版物批发；出版物零售；出版物互联网销售；组织文化艺术交流活动；文艺创作；图书管理服务；会议及展览服务；
                                        数字内容制作服务等，切实推进与全国各大出版社，作者，读者搭建服务的平台而不懈努力。
                                        “创新求精，筑文化阵地；守望初心，修书香企业”，湖北景初文化传媒有限公司以“专业、激情、诚信、感恩”为企业核心价值观
                                        ，希望通过我们的专业水平和不懈努力，秉承为“为读者找好书、为好书寻读者”的初心，让我们为每一位读者所看的书籍都是有价值，
                                        有意义的，真正让有价值的书进入社区、机关、校园、军营、家庭、农村、企业，在祖国和党的引领下，投身于书香社会的建设中去。
                                        我们相信，通过我们的不断努力和追求，一定能够在实现书香中国、民族文化自信、建成文化强国的道路上实现行业产业链的互利共赢。
                                    </p>
                                    <br />
                                    <span style="text-indent:2em;margin-left:30px">企业使命：创新求精，筑文化阵地；守望初心，修书香企业</span>
                                    <br />
                                    <span style="text-indent:2em;margin-left:30px">价值观:  &nbsp;专业 &nbsp;  激情 &nbsp; 诚信  &nbsp; 感恩    </span>

                                </div>
                            </p>
                        </div>

                        <!-- 信息模板-->
                        <!-- <script id="content_nav_Tpl" type="text/html">
                            <ul id="selectOverview">
                                {{each data as list i}}
                                <li> <a data-status={{i}} title="{{list.columnName}}" class=""
                                        href="javascript:;">{{list.columnName | columnNameformate}}</a></li>
                                {{/each}}
                                <div class="clear"></div>
                            </ul>
                        </script> -->
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
    data() {
        return {

        };
    },
    components: {
        Header,
        Footer
    },
}
</script>

<style lang="scss" scoped>
.introduce {
    margin-top: 30px;
}

.sunshine_nav {
    width: 202px;
    float: left;
}

.sunshine_content {
    float: right;
    width: 1200px;
}

.content_title {
    height: 64px;
    border-bottom: 1px solid #DFE3E5;
    line-height: 64px;
}

.content_title h3 {
    font-size: 24px;
    color: #3089e9;
    display: inline-block;
    float: left;
}

.content_title .crumbs {
    font-size: 14px;
    color: #666;
    display: inline-block;
    float: right;
}

.banner_box {
    height: 350px;
    width: 100%;
    /* background: url(../images/banner.png) no-repeat; */
    position: relative;
    z-index: 4;
}

.banner_box {
    height: 350px;
    width: 100%;
    /* background: url(../images/banner.png) no-repeat; */
    position: relative;
    z-index: 4;
}
</style>


// WEBPACK FOOTER //
// src/views/about.vue